import { ClassificationType } from "@evergis/api";

import { PARAMETER_TYPES_MAP } from "../../evergis/core/classification/classificationMapping";
import { RANGE_MIN } from "../../components/Dialogs/Classification/constants";
import { getMaxClassifyClasses } from "../../components/Dialogs/Classification/utils/getMaxClassifyClasses";
import { ClassificationParameter } from "../../interfaces/classification";
import { AppConfigState } from "../../appConfig/types";

export const isValidParameter = (parameter: string): parameter is ClassificationParameter =>
  Object.keys(PARAMETER_TYPES_MAP).includes(parameter);

export const isValidAttribute = (attribute: string, attributes: string[]): boolean => attributes.includes(attribute);

export const clampClassCount = (count: number, type: ClassificationType, appConfig: AppConfigState): number => {
  return Math.min(Math.max(count, RANGE_MIN), getMaxClassifyClasses(type, appConfig));
};
